import { Badge } from '@calendly/ui/components/badge'

import { useI18n } from 'locales'

import {
  InvoiceHeroCard,
  InvoiceHeroNumber,
  InvoiceHeroAmount,
  InvoiceHeroDue,
} from './styles'

const InvoiceMobileHero = ({
  invoice,
  amountDueValue,
  paidAtFormatted,
  dueAtFormatted,
  isPaid,
  isVoided,
  isPastDue,
}) => {
  const { i18n } = useI18n()

  return (
    <InvoiceHeroCard data-testid="invoice-hero-card">
      {isPaid && (
        <>
          <Badge type="success" data-testid="invoice-hero-paid-badge">
            {i18n.t('booking.invoice.paid')}
          </Badge>
          <InvoiceHeroAmount paid>
            {i18n.t('booking.invoice.paid_on_amount', {
              amount: amountDueValue,
              date: paidAtFormatted,
            })}
          </InvoiceHeroAmount>
          <InvoiceHeroNumber>
            {i18n.t('booking.invoice.invoice_number', {
              invoice_number: invoice.invoice_number,
            })}
          </InvoiceHeroNumber>
        </>
      )}
      {isVoided && (
        <>
          <InvoiceHeroNumber>
            {i18n.t('booking.invoice.invoice_number', {
              invoice_number: invoice.invoice_number,
            })}
          </InvoiceHeroNumber>
          <InvoiceHeroAmount strikethrough>
            {amountDueValue}
          </InvoiceHeroAmount>
          <Badge type="info" data-testid="invoice-hero-voided-badge">
            {i18n.t('booking.invoice.voided')}
          </Badge>
          <InvoiceHeroDue>
            {i18n.t('booking.invoice.voided_description')}
          </InvoiceHeroDue>
        </>
      )}
      {!isPaid && !isVoided && (
        <>
          <InvoiceHeroNumber>
            {i18n.t('booking.invoice.invoice_number', {
              invoice_number: invoice.invoice_number,
            })}
          </InvoiceHeroNumber>
          <InvoiceHeroAmount>{amountDueValue}</InvoiceHeroAmount>
          {dueAtFormatted && (
            <InvoiceHeroDue warning={isPastDue}>
              {i18n.t('booking.invoice.hero_due_date', { date: dueAtFormatted })}
            </InvoiceHeroDue>
          )}
          {isPastDue && (
            <Badge type="error" data-testid="invoice-hero-past-due-badge">
              {i18n.t('booking.invoice.past_due')}
            </Badge>
          )}
        </>
      )}
    </InvoiceHeroCard>
  )
}

export default InvoiceMobileHero
